import { Inbox } from 'lucide-react';
import type { EmptyStateProps } from './EmptyState.types';
import './EmptyState.scss';

export default function EmptyState({ icon, title, description, cta, className }: EmptyStateProps) {
  return (
    <div className={['empty-state', className || ''].filter(Boolean).join(' ')}>
      <span className="empty-state__icon" aria-hidden="true">
        {icon ?? <Inbox size={28} />}
      </span>
      <h3 className="empty-state__title">{title}</h3>
      {description ? <p className="empty-state__description">{description}</p> : null}
      {cta ? <div className="empty-state__cta">{cta}</div> : null}
    </div>
  );
}
